var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDefaultImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    fill: "#F0F0F0",
    stroke: "#E7E7E7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    width: 62,
    height: 62
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#E7E7E7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 20,
    cy: 22,
    r: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#F0F0F0",
    stroke: "#E7E7E7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    points: " 63,48 44,30 28,46 19,37 1,55 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDefaultImage);
export default __webpack_public_path__ + "static/media/iconDefaultImage.bfce4f2ffbc54721f936812891ce25c5.svg";
export { ForwardRef as ReactComponent };